module.exports = __webpack_public_path__ + "static/media/3new.4d906823.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/3new.svg
// module id = 461
// module chunks = 5